"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const List_1 = __importDefault(require("@ANITA/AnitaOptions/List"));
const SoilType_1 = __importDefault(require("./SoilType"));
const OPTIONS = [
    'soil_types',
];
class Options {
    static async load() {
        const response = (await axios_1.default.get('/toolkit/heatmap/api/options')).data;
        // Init the objects
        OPTIONS.forEach(option => {
            this.init_option(option, response[option]);
        });
    }
    static init_option(option, raws) {
        const list = this.get_list(option);
        list.reset(raws);
    }
    static get_list(option) {
        switch (option) {
            case 'soil_types':
                return this.soil_types;
        }
        throw `Unkown Option in get_list '${option}'`;
    }
}
exports.default = Options;
Options.soil_types = new List_1.default(SoilType_1.default);
